import { Box, Typography } from "@mui/material";
import Button from "../../../Buttons/Button";
import ScheduleDateSection from "./ScheduleDateSection";
import Select from "../../../Form/Select";
import TextFieldWithActions from "../../../Form/TextFieldWithActions";
import { optionsLanguage } from "../../../../utils/options";
import LoadingDots from "./LoadingDots";
import {
  BUTTON_CHANGE_CONTENT,
  BUTTON_SELECT_CONTENT,
  CONTENT,
  DESCRIPTION_INSTAGRAM_GENERATING,
  DESCRIPTION_INSTAGRAM_LABEL,
  FIELD_REQUIRED,
  MODAL_CREATE_WITH_IA_LABEL_LANGUAGE,
} from "../../../../i18n/keysTranslations";

const GeneralSettingsForm = ({
  control,
  errors,
  currentItem,
  generalLanguage,
  isGeneratingDescription,
  onGenerateDescription,
  onOpenGallery,
  generatorPlatformKey,
  showDescriptionField = true,
  t,
}) => {
  const disableGenerateDescription =
    isGeneratingDescription || !generalLanguage || !currentItem?.url;

  const descriptionLabel = isGeneratingDescription ? (
    <Box sx={{ display: "flex", gap: 1 }} component="span">
      {t(DESCRIPTION_INSTAGRAM_GENERATING)}
      <LoadingDots />
    </Box>
  ) : (
    t(DESCRIPTION_INSTAGRAM_LABEL)
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {t(CONTENT)}
        </Typography>
        <Button
          color="secondary"
          onClick={onOpenGallery}
          type="button"
          sx={{ textTransform: "none", width: "100%" }}
        >
          {currentItem?.url
            ? t(BUTTON_CHANGE_CONTENT)
            : t(BUTTON_SELECT_CONTENT)}
        </Button>
      </Box>

      <ScheduleDateSection />

      <Select
        variant="filled"
        name="language"
        control={control}
        label={t(MODAL_CREATE_WITH_IA_LABEL_LANGUAGE)}
        fullWidth
        options={optionsLanguage}
        doTranslate
        errors={errors}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />

      {showDescriptionField ? (
        <TextFieldWithActions
          label={descriptionLabel}
          name="description"
          control={control}
          showCounterCharacters
          maxLength={5000}
          fullWidth
          showAddIcon={false}
          showDeleteIcon={false}
          type="descriptions"
          platform={generatorPlatformKey}
          onGenerate={onGenerateDescription}
          disabled={disableGenerateDescription}
        />
      ) : null}
    </Box>
  );
};

export default GeneralSettingsForm;
